export default defineNuxtRouteMiddleware(async (to) => {
  const { navigateToLocalized } = useRouterUtils()

  const id = to.params?.id
  const orderId = Array.isArray(id) ? id[0] : id
  if (!orderId) return navigateToLocalized('/my-orders/single-orders')

  const { activeTabs } = await useMyOrders()

  const tabNames = activeTabs.value.map(({ name }) => name)
  if (tabNames.includes(orderId)) return true

  const type = await useOrderType().getOrderType(String(orderId))

  switch (type) {
    case ORDER_TYPES.Scratchcard:
      return navigateToLocalized(`/my-orders/scratchcard/${orderId}`)
    case ORDER_TYPES.SingleOrder:
      return navigateToLocalized(`/my-orders/single-order/${orderId}`)
    case ORDER_TYPES.Subscriptions:
      return navigateToLocalized(`/my-orders/subscription/${orderId}`)
    default:
      return create404Error()
  }
})
